import React from "react";
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import {withStyles} from '@material-ui/core/styles';
import {green} from '@material-ui/core/colors';
import PlantManagementUtility from "./PlantManagementUtility";

const GreenSwitch = withStyles({
    switchBase: {
        '&$checked': {
            color: green[500],
            '& + $bar': {
                backgroundColor: green[500]
            },
        },
    },
    checked: {},
    bar: {}
})(Switch);

const styles = theme => ({
    selectCell: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: theme.spacing.unit / 4,
        paddingRight: theme.spacing.unit / 4,
    },
    tableCell: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: theme.spacing.unit / 4,
        paddingRight: theme.spacing.unit / 4,
        textAlign: 'center',
        fontSize: '1rem',
    },
    formControlLabel: {
        fontSize: '1rem',
    }
});

const tableCellHeight = {height: 45};

const textFieldPropsStyle = {height: 22};

const textFieldStyle = {marginTop: 0, marginBottom: 0};

const textFieldNativeInputProps = {paddingTop: 0, paddingBottom: 0};

const CustomSelect = (props) => {
    let value = props.value;
    if (props.disabled && (props.value === '')) {
        if (props.isInnerGan1 === true) { // undefinedを考慮してtrue比較しておく.
            value = props.planOfCrInternalMpa; // 内面のｶﾞﾝ①の場合,工法がOFF&&実績が空の文字列の場合,「洗浄範囲(予定)」の「内面Mpa」の値を表示する.
        } else if (props.isOuterGan1 === true) { // undefinedを考慮してtrue比較しておく.
            value = props.planOfCrExternalMpa; // 外面のｶﾞﾝ①の場合,工法がOFF&&実績が空の文字列の場合,「洗浄範囲(予定)」の「外面Mpa」の値を表示する.
        }
    }

    return <TextField
        select
        fullWidth
        value={value}
        onChange={props.onChange}
        disabled={props.disabled}
        variant={props.disabled ? "filled" : "outlined"}
        SelectProps={{
            native: true,
            style: textFieldPropsStyle
        }}
        inputProps={{
            style: textFieldNativeInputProps
        }}
        style={textFieldStyle}
    >
        {props.options.map((row, i) => {
            return (<option key={i} value={row}>{row}</option>)
        })}
    </TextField>
};

class HeatExchangerCleaningRangeTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenDialog: false,
        };
        this.openDialog = this.openDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.onChangeConstructionMethod = this.onChangeConstructionMethod.bind(this);
        this.clearConstructionMethod = this.clearConstructionMethod.bind(this);
    }

    openDialog() {
        this.setState({isOpenDialog: true});
    }

    closeDialog() {
        this.setState({isOpenDialog: false});
    }

    onChangeConstructionMethod(event) {
        if (event.target.checked) {
            this.props.onChangeConstructionMethod(event, this.props);
        } else {
            this.openDialog();
        }
    }

    clearConstructionMethod() {
        let event = {target: {checked: false}};
        this.props.onChangeConstructionMethod(event, this.props);
        this.closeDialog();
    }

    render() {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(this.props.paramMapKey);
        const isDisableConstructionMethod = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD)] === '';
        const constructionMethodLabel = PlantManagementUtility.CONSTRUCTION_METHOD_LABEL_MAP.get(this.props.paramMapKey);
        const specification = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION)];
        const nozzle = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE)];
        const pressure = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)];
        const additionalReason = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON)];
        const isStart = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START)];
        const isCompletePretest = this.props.heatExchanger.resultOfProcessIsCompletePretest;
        const isStop = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP)];
        const isComplete = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE)];
        const startDatetime = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME)];
        const completeDatetime = this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME)];
        return (
            <TableRow style={tableCellHeight}>
                {this.props.children}
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    <FormControlLabel
                        control={<Switch color="primary" checked={!isDisableConstructionMethod}/>}
                        label={constructionMethodLabel}
                        labelPlacement={'start'}
                        onChange={this.onChangeConstructionMethod}
                        style={tableCellHeight}
                        classes={{label: this.props.classes.formControlLabel}}
                    />
                </TableCell>
                <TableCell className={this.props.classes.selectCell}>
                    {this.props.noSpecification !== true ?
                        this.props.isSpecificationTextField ?
                            <TextField
                                fullWidth
                                margin="dense"
                                variant={isDisableConstructionMethod ? "filled" : "outlined"}
                                value={
                                    // 超高の本数①の場合,工法がOFF&&実績が空の文字列の場合,「洗浄範囲(予定)」の「超高」の値を表示する.
                                    isDisableConstructionMethod && specification === '' && this.props.paramMapKey === PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM1 ?
                                        this.props.heatExchanger.planOfCrSuperHigh
                                        :
                                        specification
                                }
                                onChange={(event) => {
                                    this.props.onChangeSpecification(event, this.props);
                                }}
                                disabled={isDisableConstructionMethod}
                                InputProps={{
                                    style: textFieldPropsStyle,
                                    inputProps: {
                                        style: textFieldNativeInputProps
                                    }
                                }}
                                style={textFieldStyle}
                            />
                            :
                            <CustomSelect
                                options={this.props.specificationOption}
                                value={specification}
                                onChange={(event) => {
                                    this.props.onChangeSpecification(event, this.props);
                                }}
                                disabled={isDisableConstructionMethod}
                            />
                        :
                        <div/>
                    }
                </TableCell>
                <TableCell className={this.props.classes.selectCell}>
                    {this.props.noNozzle !== true &&
                    <CustomSelect
                        options={PlantManagementUtility.OPTION_NOZZLE}
                        value={nozzle}
                        onChange={(event) => {
                            this.props.onChangeNozzle(event, this.props);
                        }}
                        disabled={isDisableConstructionMethod}
                    />
                    }
                </TableCell>
                <TableCell className={this.props.classes.selectCell}>
                    {this.props.noPressure !== true &&
                    <CustomSelect
                        options={PlantManagementUtility.OPTION_PRESSURE}
                        value={pressure}
                        onChange={(event) => {
                            this.props.onChangePressure(event, this.props);
                        }}
                        disabled={isDisableConstructionMethod}
                        planOfCrInternalMpa={this.props.heatExchanger.planOfCrInternalMpa}
                        planOfCrExternalMpa={this.props.heatExchanger.planOfCrExternalMpa}
                        isInnerGan1={this.props.paramMapKey === PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN1}
                        isOuterGan1={this.props.paramMapKey === PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN1}
                    />
                    }
                </TableCell>
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    <Switch
                        color="primary"
                        checked={PlantManagementUtility.isParamTrue(isStart)}
                        onChange={(event) => {
                            this.props.onChangeStart(event, this.props);
                        }}
                        disabled={!PlantManagementUtility.isParamTrue(isCompletePretest)}
                        style={tableCellHeight}
                    />
                </TableCell>
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    <Switch
                        color="secondary"
                        checked={PlantManagementUtility.isParamTrue(isStop)}
                        onChange={(event) => {
                            this.props.onChangeStop(event, this.props);
                        }}
                        // アンドロイドアプリでは前検の実績が判定条件だが,
                        // 前検の実績なし->開始はONにできないという仕様であり,開始していないのに停止するケースは想定されないため,
                        // 開始の実績を判定条件にする.
                        disabled={!PlantManagementUtility.isParamTrue(isStart)}
                        style={tableCellHeight}
                    />
                </TableCell>
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    <GreenSwitch
                        checked={PlantManagementUtility.isParamTrue(isComplete)}
                        onChange={(event) => {
                            this.props.onChangeComplete(event, this.props);
                        }}
                        // アンドロイドアプリでは前検の実績が判定条件だが,
                        // 前検の実績なし->開始はONにできない->開始していない場合はメッセージ表示という仕様のため,
                        // 開始の実績を判定条件にする.
                        disabled={!PlantManagementUtility.isParamTrue(isStart)}
                        style={tableCellHeight}
                    />
                </TableCell>
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    {startDatetime}
                </TableCell>
                <TableCell align={"center"} className={this.props.classes.tableCell}>
                    {completeDatetime}
                </TableCell>
                <TableCell className={this.props.classes.selectCell}>
                    <CustomSelect
                        options={PlantManagementUtility.OPTION_ADDITIONAL_REASON}
                        value={additionalReason}
                        onChange={(event) => {
                            this.props.onChangeAdditionalReason(event, this.props);
                        }}
                        disabled={isDisableConstructionMethod}
                    />
                </TableCell>
                <Dialog open={this.state.isOpenDialog} onClose={this.closeDialog} style={{textAlign: 'center'}}>
                    <DialogTitle>工法のクリア</DialogTitle>
                    <DialogContent>
                        <DialogContentText>工法をクリアします。入力内容が破棄されます。よろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.clearConstructionMethod} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
            </TableRow>
        );
    }
}

HeatExchangerCleaningRangeTableRow.propTypes = {
    // isRequired.
    heatExchanger: PropTypes.object.isRequired,
    paramMapKey: PropTypes.string.isRequired,
    onChangeConstructionMethod: PropTypes.func.isRequired,
    onChangeSpecification: PropTypes.func,
    onChangeNozzle: PropTypes.func,
    onChangePressure: PropTypes.func,
    onChangeStart: PropTypes.func.isRequired,
    onChangeStop: PropTypes.func.isRequired,
    onChangeComplete: PropTypes.func.isRequired,
    onChangeAdditionalReason: PropTypes.func.isRequired,
    // option.
    isSpecificationTextField: PropTypes.bool,
    noSpecification: PropTypes.bool,
    noNozzle: PropTypes.bool,
    noPressure: PropTypes.bool,
    specificationOption: PropTypes.array,
};

export default withStyles(styles)(HeatExchangerCleaningRangeTableRow);
